import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Field } from 'formik';

import Checkbox from '../Checkbox';

import styles from './styles.scss';

const CheckboxGroup = ({ options, className, name, value, onChange, pane, style }) => (
    <div className={classNames(className, pane && styles.pane)} style={style}>
        {options.map((option, index) => {
            const isChecked = value?.includes(option.value);

            return (
                <Field
                    as={Checkbox}
                    key={name + index}
                    builderInput
                    name={name}
                    value={option.value}
                    checked={isChecked}
                    placeholder={option.label}
                    onChange={onChange}
                    className={styles.checkbox}
                    style={style}
                />
            );
        })}
    </div>
);

CheckboxGroup.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })).isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.array,
    pane: PropTypes.bool,
    style: PropTypes.object,
};

export default CheckboxGroup;
